/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrderDto,
  ResultDto,
  UpdateOrderDto,
} from '../models/index';
import {
    CreateOrderDtoFromJSON,
    CreateOrderDtoToJSON,
    ResultDtoFromJSON,
    ResultDtoToJSON,
    UpdateOrderDtoFromJSON,
    UpdateOrderDtoToJSON,
} from '../models/index';

export interface OrdersControllerCreateOrderRequest {
    createOrderDto: CreateOrderDto;
}

export interface OrdersControllerUpdateOrderRequest {
    docNum: string;
    updateOrderDto: UpdateOrderDto;
}

/**
 * 
 */
export class OrdersApi extends runtime.BaseAPI {

    /**
     */
    async ordersControllerCreateOrderRaw(requestParameters: OrdersControllerCreateOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createOrderDto'] == null) {
            throw new runtime.RequiredError(
                'createOrderDto',
                'Required parameter "createOrderDto" was null or undefined when calling ordersControllerCreateOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/orders/create`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrderDtoToJSON(requestParameters['createOrderDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async ordersControllerCreateOrder(requestParameters: OrdersControllerCreateOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.ordersControllerCreateOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async ordersControllerGetAllCompanyOrdersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/orders/getAllCompanyOrders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async ordersControllerGetAllCompanyOrders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
        const response = await this.ordersControllerGetAllCompanyOrdersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async ordersControllerGetAllUserOrdersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/orders/getAllUserOrders`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async ordersControllerGetAllUserOrders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
        const response = await this.ordersControllerGetAllUserOrdersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async ordersControllerUpdateOrderRaw(requestParameters: OrdersControllerUpdateOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['docNum'] == null) {
            throw new runtime.RequiredError(
                'docNum',
                'Required parameter "docNum" was null or undefined when calling ordersControllerUpdateOrder().'
            );
        }

        if (requestParameters['updateOrderDto'] == null) {
            throw new runtime.RequiredError(
                'updateOrderDto',
                'Required parameter "updateOrderDto" was null or undefined when calling ordersControllerUpdateOrder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/orders/{docNum}`;
        urlPath = urlPath.replace(`{${"docNum"}}`, encodeURIComponent(String(requestParameters['docNum'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrderDtoToJSON(requestParameters['updateOrderDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async ordersControllerUpdateOrder(requestParameters: OrdersControllerUpdateOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.ordersControllerUpdateOrderRaw(requestParameters, initOverrides);
    }

}
